import { BREAKPOINT, TableConfig, TableLayout } from '@spartacus/storefront'
import { EbOrderHistoryDocumentsTableDocumentCategoryComponent } from './eb-order-history-documents-table-document-category.component'
import { EbOrderHistoryDocumentsTableDownloadButtonComponent } from './eb-order-history-documents-table-download-button.component'
import { EbOrderHistoryDocumentsTableFileNameComponent } from './eb-order-history-documents-table-file-name.component'

export const ebOrderHistoryDocumentsTableConfig: TableConfig = {
  table: {
    orderHistoryDocuments: {
      cells: ['fileName', 'documentCategory', 'fileType', 'printDocumentId'],
      options: {
        layout: TableLayout.VERTICAL,
        cells: {
          fileName: {
            dataComponent: EbOrderHistoryDocumentsTableFileNameComponent
          },
          documentCategory: {
            dataComponent: EbOrderHistoryDocumentsTableDocumentCategoryComponent
          },
          fileType: {},
          printDocumentId: {
            dataComponent: EbOrderHistoryDocumentsTableDownloadButtonComponent
          }
        }
      },
      [BREAKPOINT.md]: {
        options: { layout: TableLayout.VERTICAL_STACKED }
      },
      [BREAKPOINT.sm]: {
        options: { layout: TableLayout.VERTICAL_STACKED }
      },
      [BREAKPOINT.xs]: {
        options: { layout: TableLayout.VERTICAL_STACKED }
      }
    }
  }
}

export function ebOrderHistoryDocumentsTableConfigFactory(): TableConfig {
  return ebOrderHistoryDocumentsTableConfig
}
